import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const SimpleSelect = ({ label, options, val="", onChange }) => {
    return(
        <FormControl fullWidth>
            <InputLabel>{label}</InputLabel>
            <Select
                value={val}
                label={label}
                onChange={onChange}
            >
                <MenuItem value="">Selecciona una opción</MenuItem>
                { options.map((o, i) => <MenuItem key={i} value={o?.id || o?.clave}>{o.nombre}</MenuItem>) }
            </Select>
        </FormControl>
    )
}

export default SimpleSelect;